// @owners { team: patients-team }
import { type EligiblePrescription } from '~shared/reducers/ui/progynyWizard';
import { type ReduxStateShared } from '~shared/types';

export const getProgynyWizardEligiblePrescriptions = (
  state: ReduxStateShared,
): EligiblePrescription[] | null | undefined => state.ui.progynyWizard?.eligiblePrescriptions;
